<template>
  <div>
    <Header state="coin" />
    <div class="content">
      <div class="text-center" v-if="loading === true">
        <Loader />
      </div>
      <div v-else>
        <CoinHeading :name="coinData.name" :symbol="coinData.symbol" :iconUrl="coinData.iconUrl" />
        <div>
          <PurchaseCard
            v-for="(purchase, index) in purchases"
            :key="purchase.key"
            :index="index"
            :purchaseData="purchase"
            :price="coinData.price"
            @deleted="refresh" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Service from '@/service';
import Router from '@/router';
import Header from '@/components/header/Header';
import CoinHeading from '@/components/coin/CoinHeading';
import PurchaseCard from '@/components/card/PurchaseCard';
import Loader from '@/components/loader/Loader';

export default {
  name: 'Coin',
  components: {
    Header,
    CoinHeading,
    PurchaseCard,
    Loader,
  },
  data() {
    return {
      loading: true,
      purchases: [],
      coinData: {},
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      const code = this.$route.params.code;
      if (code) {
        const userInputData = Service.getPurchase();

        // find the matching purchases
        this.purchases = userInputData.filter(elem => (elem.code.toLowerCase() === code));

        if (this.purchases.length) {
          if (this.purchases[0].id) {
            // if this is an existing coin, then fetch data for this coin
            this.getCoinData(this.purchases[0].id);
          } else {
            this.coinData = {
              name: this.purchases[0].name,
              symbol: this.purchases[0].code,
            };

            this.loading = false;
          }
        } else {
          Router.push({ name: 'Account' });
        }
      }
    },
    getCoinData(coinId) {
      if (coinId) {
        let result = {};
        Service.getCoinsByIds(coinId).then((response) => {
          if (response && response.status === 'success') {
            if (response.data && response.data.coins && response.data.coins.length === 1) {
              result = response.data.coins[0];
            }
          }

          this.coinData = result;
          this.loading = false;
        });
      }
    },
    refresh() {
      this.onLoad();
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/view/Coin.vue